module.exports = __webpack_public_path__ + "f62b200050ba6aa7a691e554969f1b3b.png";